import { Outlet } from "react-router-dom";
import { usePublicPanel } from "../../api";
import { usePanelPath } from "../../routing";
import { Page } from "../ui/Page";
import { AppFooter } from "./HelpSupport";

export function PublicLayout() {
  const panelPath = usePanelPath();
  const panel = usePublicPanel();
  return (
    <Page>
      <main className="content">
        <Outlet />
      </main>
      {!!panel.data?.supportEmail && (
        <AppFooter supportEmail={panel.data?.supportEmail} />
      )}
    </Page>
  );
}
